module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/sofa/texture.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/sofa/texture.jpg
// module id = 633
// module chunks = 0